import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, TemplateRef} from '@angular/core';
import {
    Column,
    ConfiguratorDataViewService,
    ConfiguratorTableService,
    Constraint,
    DataViewDto,
    EngineDataQueryService,
    FieldTable,
    FieldTableDto,
    ObjectQueryFilter,
    Table,
    TableJointure
} from '@tj/tj-dmp-lib-api';

import {LazyLoadEvent, MessageService, SelectItem} from 'primeng/api';
import * as _ from 'lodash';
import {CompareService} from '../data-compare/compare.service';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {RowDetailComponent} from '../table-meta/row-detail/row-detail.component';
import CategoryFieldEnum = FieldTable.CategoryFieldEnum;
import {Paginator} from '../../paginator';



@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dmp-table-meta-simple',
    templateUrl: './table-meta-simple.component.html',
    styleUrls: ['./table-meta-simple.component.scss'],
    providers: [MessageService, DialogService],
    standalone: false
})
export class TableMetaSimpleComponent implements OnChanges, OnDestroy {
    /** Exemple de valeur '500px' */
    @Input() scrollHeight: string;
    /** Exemple de valeur '500px' */
    @Input() scrollWidth: string;
    @Input() criterTemplate: TemplateRef<any>;
    @Input() datastore: string;
    @Input() partner: string;
    @Input() codeView: string;
    /**
     * permet d'afficher une liste d'accordeon des jointures
     */
    @Input() displaySubQuery = false;

    @Input() queryFilter: ObjectQueryFilter;

    @Output() rowDataSelect = new EventEmitter<any>();

    // liste de toutes les colonnes de la clause FROM
    cols: FieldTableDto[] = [];
    // liste de toutes les colonnes pouvant être affiché de la caluse SELECT
    selectCols: FieldTableDto[] = [];
    // ligne de données
    rowsData: Array<any>;
    // nombre de résultat présent en base
    totalRecords = 0;

    // premier noeud disposant de plusieurs jointures
    tableAvecPlusieursJointures: any = null;
    /**
     * colonne à afficher
     */
    displayables: FieldTableDto[] = [];
    paginator = new Paginator();
    rowByPages: SelectItem[];
    selectedRowByPage: SelectItem;
    codeTables: string[] = [];
    tables: Table[];
    selectColumns: Column[];
    loading = false;
    display = false;
    currentConstraint: Constraint = null;
    /** Liste des champs à afficher pour l'affichage de la zone d'expand */
    expandSortField: string[] = [];
    compareSortField: string[] = [];
    labelComparateur = '';
    disableComparateur = false;
    dataView: DataViewDto;
    ref: DynamicDialogRef;
    private idDataview: string;

    style: any;
    selectedColumns: any;

    constructor(
        protected tableResourceService: ConfiguratorTableService,
        protected compareService: CompareService,
        protected configuratorDataViewService: ConfiguratorDataViewService,
        protected engineDataQueryService: EngineDataQueryService,
        protected messageService: MessageService,
        protected dialogService: DialogService
    ) {
        this.init();

        this.loading = false;
        this.rowByPages = [
            {value: 10},
            {value: 20},
            {value: 30},
            {value: 40},
            {value: 50},
            {value: 100},
            {value: 200},
            {value: 500},
            {value: 1000},
        ];
        this.initPaginator();
    }

    ngOnDestroy(): void {
        if (this.ref) {
            this.ref.close();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.init();
    }

    init() {
        if (this.scrollWidth) {
            this.style = {width: this.scrollWidth};
        } else {
            this.style = null;
        }
        if (this.datastore && this.codeView) {
            this.configuratorDataViewService
                .getDataViewUsingGET(this.datastore, this.partner, this.codeView, true)
                .subscribe((res) => {
                    this.dataView = res;
                    this.idDataview = res.id;
                    // table
                    this.codeTables = res.tablesUsed;
                    this.setTableRecursif(res.table.join, res.table);
                    // select
                    this.selectColumns = (res as any).selectColumns;
                    this.loadDataOnInit();
                });
        }
    }

    loadDataOnInit() {
        this.tableResourceService
            .getTablesUsingGET(this.datastore, this.codeTables)
            .subscribe((result) => {
                this.tables = result;

                // liste des colonnes pour le filtrage
                this.tables.forEach((table) => {
                    const colForTable: FieldTableDto[] = table.fields
                        .filter(c => !(c.fk || c.pk || c.categoryField === CategoryFieldEnum.TECHNICAL))
                        .map(c => c as FieldTableDto);
                    colForTable.forEach((col) => {
                        col.table = table.code;
                        col.schema = table.schema;
                    });
                    this.cols.push(...colForTable);
                });
                this.cols = _.uniqBy(this.cols, 'code');

                // liste des colonnes pour l'affichage
                if (this.selectColumns) {
                    const tableDisplay: string[] = this.selectColumns.map(
                        (col) => col.tableName
                    );
                    this.tables
                        .filter((t) => tableDisplay.includes(t.code))
                        .forEach((table) => {
                            const colForTable: FieldTableDto[] = table.fields
                                .filter(c => !(c.fk || c.pk || c.categoryField === CategoryFieldEnum.TECHNICAL))
                                .map(c => c as FieldTableDto);
                            colForTable
                                .forEach((col) => {
                                    col.table = table.code;
                                    col.schema = table.schema;
                                });
                            this.selectCols.push(...colForTable);
                        });
                    //
                } else {
                    this.selectCols = this.cols;
                }

                //
                this.expandSortField = [];
                this.cols.forEach((f) => {
                    if (!f.code.startsWith('id')) {
                        this.expandSortField.push(f.code);
                    }
                });

                this.dataView.defaultDisplayFields.forEach(col => {
                    const sc = this.selectCols.find(s => s.table === col.tableName && s.code === col.propertyName);
                    if (sc) {
                        this.displayables.push(sc);
                    }
                });

                if (this.queryFilter) {
                    this.currentConstraint = this.queryFilter.constraint;
                    this.callSearchQuery(this.queryFilter);
                } else {
                    this.updateQuery();
                }
                //
                this.compareService.init();
                this.compareService.colsObs.next(this.cols);


            });
        //
        this.compareService.countObs.subscribe((nb) => {
            this.labelComparateur = `Comparateur (${nb}/4)`;
            this.disableComparateur = nb === 0;
        });
    }

    changeRowByPage(event) {
        this.search(false);
    }

    /**
     *
     * @param constraint contraint de recherche (filre)
     */
    updateQuery(constraint?: Constraint) {
        const query: ObjectQueryFilter = {};

        if (constraint === null) {
            this.currentConstraint = null;
        }
        if (constraint != null) {
            this.currentConstraint = constraint;
        }
        if (this.currentConstraint) {
            query.constraint = this.currentConstraint;
        }

        // query.orderings = this.orderings;

        this.loading = true;
        this.callSearchQuery(query);
    }

    private callSearchQuery(query: ObjectQueryFilter) {
        this.loading = true;
        const currentQueryFilter: ObjectQueryFilter = {
            orderings: query.orderings,
            constraint: query.constraint
        };
        this.engineDataQueryService.getQueryDataByDataviewUsingPOST(this.datastore, this.partner, this.idDataview, this.paginator.first,
            currentQueryFilter, this.paginator.rows, 'response')
            // this.queryService
            //    .sendQuery(this.datastore, query, this.paginator.start, this.paginator.pageSize)
            .subscribe((data) => {
                this.loading = false;
                this.totalRecords = +data.headers.get('x-total-count');
                this.rowsData = [];
                for (const rowData of data.body) {
                    // tslint:disable-next-line:no-shadowed-variable
                    const data = rowData.rows;
                    data['@id'] = rowData.id;
                    this.rowsData.push(data);
                }
                this.display = true;
            });
    }

    doPaginator(add: boolean) {
        if (
            add &&
            this.totalRecords > (this.paginator.first + 1) * this.paginator.rows
        ) {
            this.paginator.first++;
        } else if (!add && this.paginator.first > 0) {
            this.paginator.first--;
        }
        this.updateQuery();
    }

    loadLazy(event: LazyLoadEvent) {
        const newValue = event.first / this.paginator.rows;
        if (newValue !== this.paginator.first) {
            this.paginator.first = event.first / this.paginator.rows;
            this.updateQuery();
        }
    }

    expandChangeSortField(items) {
        this.expandSortField = items;
        if (this.compareSortField.length === 0) {
            this.compareSortField = this.expandSortField;
        }
    }

    changeCompareSortField(items) {
        this.compareSortField = items;
    }

    search(clearSaveQuery = true) {
        this.updateQuery(this.currentConstraint);
    }

    /**
     *
     * @param tables liste des jointures de tables
     * @param tableSource table parente
     */
    protected setTableRecursif(tables: Array<TableJointure>, tableSource) {
        if (tables) {
            if (this.tableAvecPlusieursJointures == null && tables.length > 1) {
                this.tableAvecPlusieursJointures = tableSource;
            }
            tables.forEach((j) => {
                this.codeTables.push(j.tableName);
                this.setTableRecursif(j.join, j);
            });
        }
    }



    openDetail(rowData) {
        this.ref = this.dialogService.open(RowDetailComponent, {
            header: 'Consultation des détails',
            closable: true,
            data: {
                rowData,
            },
            width: '70%',
            contentStyle: {'max-height': '500px', overflow: 'auto'},
        });
    }

    openPreview(rowData: any) {
        this.rowDataSelect.emit(rowData);
    }

    /**
     * Initialise la pagination
     */
    private initPaginator(onlyStartPage = false) {
        if (onlyStartPage) {
            this.paginator.first = 0;
        } else {
            this.selectedRowByPage = this.rowByPages[1];
            this.paginator.rows = this.selectedRowByPage.value;
            this.paginator.first = 0;
        }
    }

    calculateEndRecord(): number {
        const start = this.paginator.first;
        const pageSize = this.paginator.rows;

        return Math.min(start + pageSize, this.totalRecords);
    }

}
